export default "/_next/static/fonts/SmileScript-60-3e3630c445cbf5ca10b96ebc690c9b6e.woff2";